export const syncUnitOwnersForFolders = /* GraphQL */ `
  query SyncUnitOwners($filter: ModelUnitOwnerFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
    syncUnitOwners(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
      items {
        id
        ownerId
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
